/* Helpers with no dependencies.
 *
 * The point of this file is what it does not import. files/Utils.js pulls
 * moment-timezone and google-libphonenumber at module scope, so anything that
 * wanted one small pure function from it — a hex to rgba conversion, a width
 * check — took roughly three and a half megabytes of source along with it. That
 * is how a styling helper ended up putting a timezone database in front of an
 * article.
 *
 * Nothing here may ever import anything. That rule is the file.
 *
 * These are copies rather than the originals moved, deliberately: Utils is the
 * legacy app's shared surface and rewriting its callers is a separate job with
 * its own risk. The copies are four lines each and provably identical.
 */

export const isMobile = () => window.innerWidth < 576;

export const hexToRGBA = (hex, alpha) => {

    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {

        let c = hex.substring(1).split('');
        if(c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
    }
    return hex;
};

export default { hexToRGBA, isMobile };
